import {onDomReady} from "./observer.js";

class Gallery {
    constructor() {
        this.options = {
            galleryInput: '[data-gallery-input]',
            galleryChecked: '[data-gallery-checked]',
        };

        this.elements = {
            galleryInputElement: document.querySelector(this.options.galleryInput),
            galleryCheckedElements: document.querySelectorAll(this.options.galleryChecked),
        };

        this.init();
    }


    init() {
        if (this.elements.galleryInputElement) {
            const galleryInputPointer = this.elements.galleryInputElement;
            galleryInputPointer.addEventListener('input', function () {
                this.style.height = 'auto'; // Reset height to recalculate
                this.style.height = this.scrollHeight + 'px'; // Set new height based on content
            });
        }

        if (this.elements.galleryCheckedElements) {
            const galleryCheckedElements = this.elements.galleryCheckedElements;
            galleryCheckedElements.forEach((galleryCheckedElement) => {
                const galleryCheckedPointer = galleryCheckedElement;
                galleryCheckedPointer.addEventListener('click', () => {
                    galleryCheckedPointer.classList.toggle('_checked');
                });
            });
        }
    }
}

onDomReady(() => {
    const header = new Gallery();
}, false);